/**
 * @fileoverview Syndicator Showdown — Real-Time Saturday Leaderboard Screen
 * @module pages/LeaderboardPage
 *
 * Thin route wrapper around the shared LeaderboardDetail component — see
 * components/leaderboard/LeaderboardDetail.jsx for the actual scoreboard +
 * My Stable Progress rendering, also reused by /leaderboards.
 */

import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { LeaderboardDetail } from '../components/leaderboard/LeaderboardDetail';

export const LeaderboardPage = () => {
  const { slateId } = useParams();
  const [searchParams] = useSearchParams();
  const highlightRaceId = searchParams.get('race');

  return (
    <div className="dashboard-container">
      <LeaderboardDetail slateId={slateId} highlightRaceId={highlightRaceId} />
    </div>
  );
};

export default LeaderboardPage;
